import React from 'react'
import * as S from './styles'
import { HelpRequestIndicatorCard } from 'presentation/hospital/layouts/ActiveSearch/Cards/HelpRequestIndicatorCard'
import { ReactComponent as TotalNeedHelpIcon } from 'presentation/assets/icons/total-need-help-icon.svg'
import { ReactComponent as UnsolvedNeedHelpIcon } from 'presentation/assets/icons/unsolved-need-help-icon.svg'
import { ReactComponent as InProgressNeedHelpIcon } from 'presentation/assets/icons/in-progress-need-help-icon.svg'
import { ReactComponent as ResolvedNeedHelpIcon } from 'presentation/assets/icons/resolved-need-help-icon.svg'
import { HelpCardType } from 'domain/usecases/active-search/load-active-search-statistics'
import { ActiveSearchSurgeryType } from 'common/enum/active-search-surgery-type'
import {
  ActiveSearchHelpStatus,
  ActiveSearchHelpStatusTranslated
} from 'common/enum/active-search-help-status'

type LoadActiveSearchProps = {
  headerTitle?: string
  type?: ActiveSearchSurgeryType
  status?: ActiveSearchHelpStatus
}

type HelpCardPanelProps = {
  helpCardInfo: HelpCardType
  handleRedirectToDataGrid: (params?: LoadActiveSearchProps) => void
}
const HelpRequestsIndicators = ({
  helpCardInfo,
  handleRedirectToDataGrid
}: HelpCardPanelProps) => {
  return (
    <S.Wrapper>
      <HelpRequestIndicatorCard
        title={ActiveSearchHelpStatusTranslated.ALL}
        quantity={String(helpCardInfo.total).padStart(2, '0')}
        icon={<TotalNeedHelpIcon />}
        color="danger800"
        onClick={() =>
          handleRedirectToDataGrid({
            headerTitle: ActiveSearchHelpStatusTranslated.ALL,
            status: ActiveSearchHelpStatus.ALL
          })
        }
      />

      <HelpRequestIndicatorCard
        title={ActiveSearchHelpStatusTranslated.PENDENT}
        quantity={String(helpCardInfo.pendent).padStart(2, '0')}
        color="attention900"
        icon={<UnsolvedNeedHelpIcon />}
        onClick={() =>
          handleRedirectToDataGrid({
            headerTitle: ActiveSearchHelpStatusTranslated.PENDENT,
            status: ActiveSearchHelpStatus.PENDENT
          })
        }
      />

      <HelpRequestIndicatorCard
        title={ActiveSearchHelpStatusTranslated.IN_PROGRESS}
        quantity={String(helpCardInfo.in_progress).padStart(2, '0')}
        color="secondary700"
        icon={<InProgressNeedHelpIcon />}
        onClick={() =>
          handleRedirectToDataGrid({
            headerTitle: ActiveSearchHelpStatusTranslated.IN_PROGRESS,
            status: ActiveSearchHelpStatus.IN_PROGRESS
          })
        }
      />

      <HelpRequestIndicatorCard
        title={ActiveSearchHelpStatusTranslated.RESOLVED}
        quantity={String(helpCardInfo.resolved).padStart(2, '0')}
        icon={<ResolvedNeedHelpIcon />}
        color="primary800"
        onClick={() =>
          handleRedirectToDataGrid({
            headerTitle: ActiveSearchHelpStatusTranslated.RESOLVED,
            status: ActiveSearchHelpStatus.RESOLVED
          })
        }
      />
    </S.Wrapper>
  )
}

export default HelpRequestsIndicators
